import { Outlet } from "react-router";
import {Container, Row, Col} from 'react-bootstrap';

import Menu from './Menu';


export default function Layout() {
	return (
	    <>
		<Menu />
		 <Container className='fluid mainContent'>
     	  <Row>
      	   <Col>
			<Outlet />
			<br />
			<br />
		   </Col>
		  </Row>
		 </Container>
    </>
	);
}
